









































































import Vue from 'vue';
import Text from '@tiptap/extension-text';
import Paragraph from '@tiptap/extension-paragraph';
import Document from '@tiptap/extension-document';
import CommunityMention from '@/web/components/community/community-mention';
import Image from '@tiptap/extension-image';
import { generateHTML } from '@tiptap/html';
import Link from '@tiptap/extension-link';
import HardBreak from '@tiptap/extension-hard-break';
import Heading from '@tiptap/extension-heading';
import Code from '@tiptap/extension-code';
import CodeBlock from '@tiptap/extension-code-block';
import Blockquote from '@tiptap/extension-blockquote';
import BulletList from '@tiptap/extension-bullet-list';
import OrderedList from '@tiptap/extension-ordered-list';
import ListItem from '@tiptap/extension-list-item';
import Italic from '@tiptap/extension-italic';
import Bold from '@tiptap/extension-bold';
import { sanitize } from '@/core/utils/utils';

export default Vue.extend({
  name: 'FlaggedCommentDetailsFormModal',
  props: {
    confirm: null,
    comment: {
      type: Object as () => CommunityCommentResponse,
      required: true,
    },
  },
  computed: {
    getRouteName() {
      if (!this.comment) return null;

      if (this.comment.additional_data?.playlist_id) {
        return 'studio-playlist-media';
      }
      if (this.comment.additional_data?.lesson_id) {
        return 'studio-lesson-media';
      }
      if (this.comment.additional_data?.group_id) {
        return 'studio-community-group';
      }
      return 'studio-media';
    },
    getRouteParams() {
      if (this.comment.additional_data?.group_id) {
        return {
          studio_url: this.comment?.additional_data?.studio_url,
          group_id: this.comment?.additional_data?.group_id,
        };
      }
      return {
        ...this.comment?.additional_data,
        media_id: this.comment?.entity_id,
      };
    },
    getRouteQueryParams() {
      return {
        comment: this.comment?.id,
      };
    },
    parsedComment() {
      if (!this.comment) return {};
      return {
        ...this.comment,
        parsedContent: this.jsonToHtmlContent(this.comment.content),
      };
    },
  },
  methods: {
    async onConfirm() {
      await this.confirm(this.comment);
      await this.$emit('close');
    },
    async onDiscard() {
      if (this.discard) {
        await this.discard();
      }
      await this.$emit('close');
    },
    jsonToHtmlContent(jsonContent) {
      if (typeof jsonContent === 'string') {
        jsonContent = JSON.parse(jsonContent);
      }
      return sanitize(
        generateHTML(jsonContent, [
          Document,
          Paragraph,
          Text,
          CommunityMention.CommunityMention,
          Image,
          HardBreak,
          Heading,
          Code,
          CodeBlock,
          BulletList,
          OrderedList,
          ListItem,
          Link,
          Italic,
          Bold,
          Blockquote,
        ])
      );
    },
  },
});
